import * as React from 'react';
import { useTheme, type IconButtonProps } from '@mui/material';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FlexyIconButton, IconType } from '../FlexyIconButton';

export type ClearButtonProps = {
    size?: SizeProp;
    color?: IconButtonProps['color'];
    tooltip?: string;
    onClick?: IconButtonProps['onClick'];
    disabled?: IconButtonProps['disabled'];
    confirmation?: boolean;
    icon?: IconType;
};

export const ClearButton: React.FunctionComponent<ClearButtonProps> = function ({
    size,
    color,
    tooltip = 'Supprimer',
    onClick = undefined,
    disabled = false,
    confirmation = false,
    icon = ['fasl', 'times'],
}: ClearButtonProps) {
    const { palette } = useTheme();

    return (
        <FlexyIconButton
            icon={icon}
            displayTooltip
            tooltipOverwriteProps={{
                title: tooltip,
            }}
            iconOverwriteProps={{
                color: color || palette.text.secondary,
                size: size || '2xs',
            }}
            confirmation={confirmation}
            confirmationTooltip="Cliquez pour confirmer la suppression"
            normalHoverColor={palette.error.main}
            onClick={onClick}
            disabled={disabled}
        />
    );
};
